import type { ReactNode } from 'react'

import { canAccessProduct, productById } from '@/app/module-registry'
import { usePermissions } from '@/lib/use-permissions'
import { LoadingNotice } from '@/ui/loading-notice'
import { NoAccess } from '@/ui/no-access'

export function ProductGuard({
  product,
  children,
}: {
  product: string
  children: ReactNode
}) {
  const { can, ready } = usePermissions()
  const definition = productById(product)

  if (!ready) return <LoadingNotice message="Loading permissions…" />
  if (!definition || !canAccessProduct(definition, can)) return <NoAccess />
  return <>{children}</>
}
